import { render, staticRenderFns } from "./online-exam.vue?vue&type=template&id=6eda7226"
import script from "./online-exam.vue?vue&type=script&lang=ts"
export * from "./online-exam.vue?vue&type=script&lang=ts"
import style0 from "./online-exam.vue?vue&type=style&index=0&id=6eda7226&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports